import * as React from 'react';
import { connect } from 'react-redux';
import AppActions from '../../app/app_actions';
import { AppConstants } from '../../constants/AppConstants';
import { DateFormatter, i18n, isAuth } from 'arm-common';
import * as agui from 'arm-gui/dist/controls';
import ProdottoActions from './prodotto_actions';
import { rejects } from 'assert';
import { isNullOrUndefined } from 'util';
import Upload from './uploadJSON.jsx';
import ConfirmModalDeleteV4 from '../shared/confirmModalDeleteV4.jsx'
import ApplicationData from '../../app/aApplicationData'
import FormatMoney from '../shared/formatMoney.js';
import GaranziePremio from './garanziePremio.jsx'



class ProdottoQuotazione extends React.Component {
    constructor(props) {
        super(props);
        this.componentName = '[ProdottoQuotazione.jsx] ';
        this.state = {
            showConfirm: false,
            showConfirmDelete: false,
            prodottoDaEliminare: null
        }
        this.showConfirmPanelUploadJSON = this.showConfirmPanelUploadJSON.bind(this);
        this.deleteDocumentPolizza = this.deleteDocumentPolizza.bind(this);
        this.showConfirmDelete = this.showConfirmDelete.bind(this);
        this.getDocumentiProdottoQuotazione = this.getDocumentiProdottoQuotazione.bind(this);
    }

    componentDidMount() {
        console.log(this.componentName + ' componentDidMount');

        //definisco le colonne della boostrap table
        let columns = [
            // { field: 'id', title: i18n('ARM_CORE_PRODUCT.MANAGE.ID', 'Id'), align: "center", sortable: 'true' },
            // { field: 'name', title: i18n('ARM_CORE_PRODUCT.MANAGE.NOME', 'Nome'), align: "center", sortable: 'true' },
            { field: 'name', title: i18n('ARM_CORE_PRODUCT.MANAGE.DOCUMENTO', 'Documento'), align: "center", sortable: 'true', formatter: this.documentTypeFormatter },
            { field: 'nota', title: i18n('ARM_CORE_PRODUCT.MANAGE.PREMIO', 'Premio'), align: "center", sortable: 'true' },
            // { field: 'countDownload', title: i18n('ARM_CORE_PRODUCT.MANAGE.DOWNLOAD_COUNT', 'Download Count'), align: "center", sortable: 'true' },
            { field: 'dateCre', title: i18n('ARM_CORE_PRODUCT.SHARED.DATA_RUN', 'Data run'), align: "center", sortable: 'true', formatter: this.dateFormatter },
            // { field: 'idUserCre', title: i18n('ARM_CORE_PRODUCT.SHARED.CREATO_DA', 'Creato da'), align: "center", sortable: 'true' },
            { field: 'run', title: i18n('ARM_CORE_PRODUCT.SHARED.RUN', 'Run'), align: "center", formatter: this.columnDownload },
            { field: 'elimina', align: 'center', title: i18n("ARM_CORE_PRODUCT.SHARED.ELIMINA", "Elimina"), formatter: this.columnDelete },
        ];



        $(this.refs.MyTable).bootstrapTable({
            columns: columns,
            idField: "id",
            sortable: true,
            search: true,
            showColumns: true,
            showExport: true,
            exportDataType: 'all',
            exportTypes: ['csv', 'excel'],
            onClickRow: (row, $element, field) => this.downloadOnClick(row, $element, field),
            sortOrder: "desc",
            pagination: true,


        });


        if (this.props.rows !== null && this.props.rows !== undefined) {

            $(this.refs.MyTable).bootstrapTable('load', this.props.rows);
        }
    }

    downloadOnClick(row, $element, field) {
        console.log(this.componentName + " showConfirmPanel()");

        if (field === "name" && row.id) {
            this.props.downloadDocument(row.downloadLink);
        }
        if (field === "edit") {
            if (row.id) {
                this.inzializzaEliminaDocument(row.id);
            } else {
                this.setState({ docCategory: row.documentType })
                this.showConfirmPanel();
            }
        } else if (field === "elimina") {
            this.inzializzaEliminaDocument(row.id);
        } else if (field === "run") {
            this.props.quotationJSON(row.id).then(
                resolve => {
                    this.props.getRulelog(this.props.idProdotto);
                    this.getDocumentiProdottoQuotazione(this.props.idProdotto);
                }
            )
        }

    }

    dateFormatter(value, row, index) {

        let properties = row.properties;

        if (properties && properties.includes("runDate")) {
            let res = properties.split("=");
            if (res && res.length > 1) {
                return DateFormatter.dataFormatter(res[1]);
            }
        }
        return '-';

    }

    columnDelete(value, row, index) {
        console.log(this.componentName + " columnDelete: " + index);
        let temp;
        temp = "<button class='btn btn-danger btn-sm'><i class='fas fa-trash-alt' data-toggle='tooltip' data-placement='top' title='Elimina'/></button>";
        return temp;
    }

    inzializzaEliminaDocument(idProdottoDocument) {

        this.setState({ prodottoDaEliminare: idProdottoDocument, showConfirmDelete: true });

    }

    showConfirmDelete() {
        this.setState({ showConfirmDelete: !this.state.showConfirmDelete });
    }

    deleteDocumentPolizza() {

        this.showConfirmDelete();

        this.props.deleteDocumentPolizza(this.state.prodottoDaEliminare).then(

            resolve => {
                this.props.getDocumentiProdottoQuotazione(this.props.idProdotto).then(

                    resolve => {
                        if (this.props.rows !== null && this.props.rows !== undefined) {

                            $(this.refs.MyTable).bootstrapTable('load', this.props.rows);
                        }
                    })
            }
        )
    }


    documentTypeFormatter(value, row, index) {
        if (row.id) {
            return '<a style = "color: #007bff; text-decoration: underline;">' + value + '</a>'
        }
        return value;
        // return ApplicationData.domainVal('AI_DOCUMENT_CATEGORY', value, value).desDom;
    }

    dateFormatterShort(value, row, index) {
        return DateFormatter.dataFormatterShort(value);
    }

    showConfirmPanelUploadJSON() {
        console.log(this.componentName + " showConfirmPanel()");

        this.setState({ showConfirm: !this.state.showConfirm })

    }

    columnDownload(value, row, index) {
        console.log("columnDownload:" + index);
        let temp;

        temp = "<button class='btn btn-primary btn-sm'><i class='fas fa-play' data-toggle='tooltip' data-placement='top' title='Run'/></button>";
        return temp;
    }


    componentWillReceiveProps(nextProps) {
        console.log(this.componentName + ' componentWillReceiveProps');
        if (nextProps.rows !== this.props.rows) {
            // console.log("\t rows: " + (nextProps.rows !== null ? nextProps.rows.length : "NULL"));
            if (nextProps.rows === null || nextProps.rows === undefined) {
                $(this.refs.MyTable).bootstrapTable('removeAll');
            } else {
                $(this.refs.MyTable).bootstrapTable('load', nextProps.rows);
            }
        }
    }

    getDocumentiProdottoQuotazione(id) {

        this.props.getDocumentiProdottoQuotazione(id).then(
            resolve => {
                if (resolve) {
                    $(this.refs.MyTable).bootstrapTable('load', resolve);
                }
            }
        )

    }

    render() {
        console.log(this.componentName + ' render');
        return (
            <>
                <div className="card col-6 mt-4">
                    <div className="mt-3">
                        <div className="card-header">
                            <agui.aButton
                                bs="primary"
                                className="float-right ml-2"
                                icon="fas fa-upload"
                                onClick={this.showConfirmPanelUploadJSON}
                            >
                                {i18n('ARM_CORE_PRODUCT.SHARED.UPLOAD', 'Upload')}
                            </agui.aButton>
                            <h3>{i18n('ARM_CORE_PRODUCT.PRODOTTO.DOC_QUOTAZIONE', 'Documenti di quotazione')}</h3>
                        </div>

                        <table ref="MyTable" className={AppConstants.CLASS_TABLE} />

                        {this.props.ruleLog ? (
                            <ul style={{ backgroundColor: 'black', color: 'white' }}>
                                {this.props.ruleLog.map((element, index) => (
                                    <li key={`rule${index}`} id={`rule${index}`} className="row">
                                        {element.descrizione}
                                    </li>
                                ))}
                            </ul>
                        ) : null}

                        <div className="col-12 p-0 mt-5">
                            <table className="w-100" style={{ border: 'none' }}>
                                <thead>
                                    <tr>
                                        <th>{i18n('ARM.CORE.PRODUCT.PREMIO.LORDO', 'Lordo')}</th>
                                        <th>{i18n('ARM.CORE.PRODUCT.PREMIO.NETTO', 'Netto')}</th>
                                        <th className="pr-2">{i18n('ARM.CORE.PRODUCT.PREMIO.ACCESSORI', 'Accessori')}</th>
                                        <th>{i18n('ARM.CORE.PRODUCT.IMPORTO.IMPOSTE', 'Imposte')}</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr key="premioScomposto">
                                        <td>
                                            {FormatMoney.formatMoney(
                                                this.props.prodotto.premio?.premioLordo,
                                                2,
                                                ',',
                                                '.'
                                            )}
                                        </td>
                                        <td>
                                            {FormatMoney.formatMoney(
                                                this.props.prodotto.premio?.premioNetto,
                                                2,
                                                ',',
                                                '.'
                                            )}
                                        </td>
                                        <td>
                                            {FormatMoney.formatMoney(
                                                this.props.prodotto.premio?.accessoriDiv,
                                                2,
                                                ',',
                                                '.'
                                            )}
                                        </td>
                                        <td>
                                            {FormatMoney.formatMoney(
                                                this.props.prodotto.premio?.imposteDiv,
                                                2,
                                                ',',
                                                '.'
                                            )}
                                        </td>
                                    </tr>
                                </tbody>
                            </table>

                            <GaranziePremio
                                prodotto={this.props.prodotto}
                                listaPremiPojo={this.props.prodotto.premio?.listaPremiPojo || null}
                                premio={this.props.prodotto.premio}
                            />
                        </div>

                        <Upload
                            idProdotto={this.props.idProdotto}
                            getDocumentiProdottoQuotazione={this.getDocumentiProdottoQuotazione}
                            show={this.state.showConfirm}
                            close={this.showConfirmPanelUploadJSON}
                        />

                        <ConfirmModalDeleteV4
                            show={this.state.showConfirmDelete}
                            deleteOnClick={this.deleteDocumentPolizza}
                            onClose={this.showConfirmDelete}
                        />
                    </div>
                </div>
            </>
        );
    }

}


export default ProdottoQuotazione;
